import { Typography } from "@mui/material";
import { useEffect } from "react";
import { BiPhone } from "react-icons/bi";
import { MdEmail, MdPlace } from "react-icons/md";

const PrivacyPolicy = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="term-of-use-page" style={{ marginTop: "130px" }}>
            <div className="top-section bg-el">
                <div className="page-section bg-el">
                    <Typography className="heading clr-pm" variant="h3" component="h2" fontWeight={600}>
                        Privacy Policy
                    </Typography>
                </div>
                {/* </div>

            <div className="top-section"> */}
                <div className="page-section">
                    <div className=" pb2">
                        <Typography variant="h5" fontWeight={600} className="">
                            Objective:
                        </Typography>

                        <p className="pt2">
                            This Privacy Statement outlines our commitment to safeguarding the privacy of personal
                            information collected and processed through various means. While this statement primarily
                            addresses data collected via our website —{" "}
                            <span className="clr-pm hover:underline cursor-pointer">www.appretive.com</span> — and
                            related online services that link to this Privacy Policy (collectively referred to as the
                            “Appretive Website”), the principles outlined herein reflect our global privacy practices
                            and standards across all operations involving personal data.
                        </p>

                        <p className="pt2">
                            Depending on your relationship with Appretive and the context in which your personal data is
                            collected (e.g., client, vendor, job applicant, or visitor), we may offer additional,
                            purpose-specific privacy disclosures. These may vary based on applicable legal requirements
                            and regional regulations.
                        </p>

                        <p className="pt2">This Privacy Policy explains:</p>

                        <div className="pt2">
                            <li className="">What personal information we collect</li>
                            <li className="">How we use and share that information</li>
                            <li className="">Your rights and choices</li>
                            <li className="">How you can contact us regarding your data</li>
                        </div>

                        <p className="pt2">
                            Where translations of this policy are provided, the English version shall govern in the
                            event of a conflict.
                        </p>
                    </div>

                    <div className="pt2 pb2">
                        <Typography variant="h5" fontWeight={600} className="">
                            Scope of this Privacy Policy:
                        </Typography>

                        <p className="pt2">
                            This Privacy Policy governs our information collection and handling practices, including how
                            we collect, use, share, and secure the personal data you provide while interacting with the
                            Appretive Website or services that link to this policy.
                        </p>

                        <p className="pt2">
                            The Appretive Website may include links to third-party websites or services for your
                            convenience. These third-party websites operate independently and have their own privacy
                            policies and practices. Appretive does not endorse or control such third-party sites and is
                            not responsible for their content or privacy practices. We encourage you to review the
                            privacy policies of any external websites you visit before providing any personal
                            information.
                        </p>

                        <p className="pt2">
                            We may also incorporate features that allow you to interact with Appretive on social media
                            platforms. Your use of these features may lead to the sharing of personal data based on your
                            social media privacy settings. We recommend reviewing the privacy preferences and policies
                            of any social platforms with which you interact.
                        </p>
                    </div>

                    <div className="pt2 pb2">
                        <Typography variant="h5" fontWeight={600}>
                            Categories of Personal Information We Collect
                        </Typography>

                        <p className="pt2">
                            Depending on your interaction with us, we may collect the following categories of personal
                            information either directly or indirectly:
                        </p>

                        <div className="pt2">
                            <li className="">Name, email address, contact number, and job title</li>
                            <li className="">Company name, business contact details</li>
                            <li className="">IP address, device details, browser type, and geolocation data</li>
                            <li className="">User activity and interaction data on our website</li>
                            <li className="">
                                Resume/CV details, professional qualifications (when applying for careers)
                            </li>
                            <li className="">Any personal data you voluntarily submit via forms or communications</li>
                        </div>
                    </div>

                    <div className="pt2 pb2">
                        <Typography variant="h5" fontWeight={600}>
                            How We Use Your Personal Information
                        </Typography>

                        <p className="pt2">The personal information we collect is used for the following purposes:</p>

                        <div className="pt2">
                            <li className="">To respond to your inquiries or service requests</li>
                            <li className="">To deliver information, services, or support that you request from us</li>
                            <li className="">To improve our website, products, and services through analytics</li>
                            <li className="">For marketing and communication purposes (where legally permissible)</li>
                            <li className="">For recruitment and onboarding processes</li>
                            <li className="">To comply with legal obligations or enforce legal rights</li>
                        </div>
                    </div>

                    <div className="pt2 pb2">
                        <Typography variant="h5" fontWeight={600}>
                            Information Collected from Third-Party Sources
                        </Typography>

                        <p className="pt2">
                            We may obtain personal information from third-party sources to enhance our services, such
                            as:
                        </p>

                        <div className="pt2">
                            <li className="">Publicly available databases and professional networking platforms</li>
                            <li className="">Partners, service providers, and business affiliates</li>
                            <li className="">Social media platforms, depending on your settings and permissions</li>
                        </div>
                    </div>

                    <div className="pt2 pb2">
                        <Typography variant="h5" fontWeight={600}>
                            Engagement Through Social Media
                        </Typography>

                        <p className="pt2">
                            When you interact with Appretive through social media platforms (e.g., LinkedIn, Twitter,
                            Facebook), we may collect information made available to us by those platforms, including
                            your profile name, contact information, or engagement metrics, in accordance with your
                            privacy settings.
                        </p>

                        <p className="pt2">
                            We encourage you to review your social media account settings and the privacy policies of
                            those platforms to understand how your data may be used or shared.
                        </p>
                    </div>

                    <div className="pt2 pb2">
                        <Typography variant="h5" fontWeight={600}>
                            Sharing of Personal Information
                        </Typography>

                        <p className="pt2">
                            Appretive does not sell or rent your personal data. We may share personal information with:
                        </p>

                        <div className="pt2">
                            <li className="">Our employees, subsidiaries, or affiliates, on a need-to-know basis</li>
                            <li className="">
                                Trusted third-party service providers who perform services on our behalf
                            </li>
                            <li className="">
                                Legal or regulatory authorities, when required by law or judicial process
                            </li>
                            <li className="">
                                Business partners in cases of joint services or integrations, with appropriate
                                safeguards
                            </li>
                        </div>
                    </div>

                    <div className="pt2 pb2">
                        <Typography variant="h5" fontWeight={600}>
                            Data Retention
                        </Typography>

                        <p className="pt2">
                            Appretive retains personal data only as long as necessary to fulfill the purposes for which
                            it was collected, or as required under applicable legal, regulatory, or contractual
                            obligations. Once the retention period ends, data is securely deleted or anonymized.
                        </p>
                    </div>

                    <div className="pt2 pb2">
                        <Typography variant="h5" fontWeight={600}>
                            Your Rights
                        </Typography>

                        <p className="pt2">
                            Subject to applicable laws, you may have the following rights regarding your personal
                            information:
                        </p>

                        <div className="pt2">
                            <li className="">Right to access and obtain a copy of your personal data</li>
                            <li className="">Right to correct or update inaccurate or incomplete data</li>
                            <li className="">Right to request deletion of your data</li>
                            <li className="">Right to object to processing under certain circumstances</li>
                            <li className="">Right to withdraw consent (where processing is based on consent)</li>
                            <li className="">Right to lodge a complaint with a data protection authority</li>
                        </div>

                        <p className="pt2">
                            To exercise any of these rights, please contact us at{" "}
                            <span className="clr-pm hover:underline cursor-pointer">privacy@appretive.com</span>.
                        </p>
                    </div>

                    <div className="pt2">
                        <Typography variant="h5" fontWeight={600} className="">
                            Contact Us:
                        </Typography>

                        <p className="pt2">
                            If you have any questions or concerns regarding this Privacy Policy or your personal
                            information, please reach out to:
                        </p>

                        <p className="flex gap-1 pt1">
                            <MdEmail className="text-2xl" /> Email:{" "}
                            <span className="clr-pm hover:underline cursor-pointer">hr@appretive.com</span>
                        </p>

                        <p className="flex gap-1 pt1">
                            <BiPhone className="text-2xl" /> Phone:{" "}
                            <span className="clr-pm hover:underline cursor-pointer">+91 79842 05484</span>
                        </p>

                        <p className="flex gap-1 pt1">
                            <MdPlace className="text-2xl" /> Address:{" "}
                            <span className="">
                                455, 4th Floor, Royal Arcade, near Sarthana Jakatnaka, Surat, Gujarat 395006
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
